import koKR from 'antd/locale/ko_KR';
import type { CustomLocale } from '../types/antd';

const custom: CustomLocale = {
  CopyButton: {
    label: '복사하기',
    successText: '복사되었습니다.',
    failedText: '복사에 실패했습니다.',
  },
  ToggleButton: {
    activeText: '활성화',
    inactiveText: '비활성화',
  },
};

export default {
  ...koKR,
  custom,
};
